import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { useAuthDispatch } from "../../Context";
import PropTypes from "prop-types";
import { fetchDashboardThumbnail } from "../../api/dashboardService";
import { fetchAuthSession } from "aws-amplify/auth";
import { ProgressSpinner } from "primereact/progressspinner";
import { Box } from "@mui/material";

const MediaCard = ({ data = {} }) => {
  console.log("dashboard data", data);

  const [thumbnail, setThumbnail] = useState(""); // State to store the image
  const [loading, setLoading] = useState(true); // State to track loading
  const [error, setError] = useState(null); // State to track errors

  const navigate = useNavigate();
  const dispatch = useAuthDispatch();

  // Fetch the thumbnail when the component mounts
  useEffect(() => {
    const fetchThumbnail = async () => {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens.idToken;
        const image = await fetchDashboardThumbnail(
          {
            site_id: data.site_id, // Pass site_id
            site_contentUrl: data.site_contentUrl, // Pass site_contentUrl
            workbook_id: data.workbook_id, // Pass workbook_id
            view_id: data.view_id, // Pass view_id
          },
          token
        );
        setThumbnail(image);
      } catch (err) {
        console.error("Error fetching thumbnail:", err);
        setError("Failed to load image");
      } finally {
        setLoading(false);
      }
    };

    fetchThumbnail();
  }, [data]);

  const handleViewClick = () => {
    const path = `/dashboard/${data.site_contentUrl}-${data.workbook_contentUrl}-${data.view_viewUrlName}`;
    navigate(path, {
      state: {
        view_viewUrlName: data.view_viewUrlName,
        workbook_contentUrl: data.workbook_contentUrl,
        site_contentUrl: data.site_contentUrl,
      },
    });
    // dispatch({ type: "NAVIGATE", payload: path });
  };
  return (
    <Card sx={{ width: 265 }} data-testid="dashboard-card">
      {loading ? (
        <Box
          sx={{
            height: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ProgressSpinner
            style={{
              width: "3rem", // 3 times the root font size
              height: "3rem", // 3 times the root font size
            }}
          />
        </Box>
      ) : error ? (
        <CardMedia
          sx={{ height: 200, backgroundSize: "contain" }}
          image="/error-image.png" // Placeholder for errors
          title="Error loading image"
        />
      ) : (
        <CardMedia
          sx={{ height: 200, backgroundSize: "contain" }}
          image={thumbnail} // Use the fetched thumbnail
          title={data.view}
        />
      )}
      <CardContent sx={{ pb: 0, "&:last-child": { pb: 0 } }}>
        <Typography
          gutterBottom
          variant="h6"
          component="div"
          sx={{
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            height: "4rem", // Adjust based on your theme's typography h6 line-height and desired spacing
            textOverflow: "ellipsis",
          }}
        >
          {data.tilename}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 6, // Adjust the number of lines you want to show before truncating
            textOverflow: "ellipsis",
            height: "8rem", // Adjust based on your desired height
          }}
        >
          {data.description}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: "center" }}>
        <Button
          size="small"
          onClick={handleViewClick}
          sx={{ textTransform: "none", fontSize: "16px" }}
        >
          View
        </Button>
      </CardActions>
    </Card>
  );
};

MediaCard.propTypes = {
  data: PropTypes.object.isRequired,
};

export default MediaCard;
